import DepositPackingComponent from './deposit_packing.component';
import printDepositPackingModule from './print';


let depositPackingModule = angular.module('depositPacking', [
    printDepositPackingModule
])

    .config(($stateProvider, $urlRouterProvider) => {
        "ngInject";

        $urlRouterProvider.otherwise('/deposit-packing');

        $stateProvider
            .state('depositPacking', {
                url: '/deposit-packing',
                component: 'depositPacking',
                data: {
                    requireLogin: true,
                    requireACL: 'deposit_packing.all'
                },
                parent: 'app'
            });
    })

    .component('depositPacking', DepositPackingComponent)

    .name;

export default depositPackingModule;


// WEBPACK FOOTER //
// ./client/app/components/deposit_packing/index.js